import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=4b98e100&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=4b98e100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b98e100",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutListNavigationDrawer: require('C:/Users/Maristela/loja/components/Layout/ListNavigationDrawer.vue').default,CartNavigationDrawer: require('C:/Users/Maristela/loja/components/CartNavigationDrawer.vue').default,CartEmpty: require('C:/Users/Maristela/loja/components/CartEmpty.vue').default,DarkMode: require('C:/Users/Maristela/loja/components/DarkMode.vue').default,ContaLogin: require('C:/Users/Maristela/loja/components/ContaLogin.vue').default,LayoutListAppBar: require('C:/Users/Maristela/loja/components/Layout/ListAppBar.vue').default})
